import api from './http'

/* *****뉴스룸-보도자료 FRONT API***** */

// 뽀도자료 목록 조회
const getReport = (data = null, callback, errorHandler) => {
  return api.getPromise('GET', '/api/report', data)
}

// 보도자료 상세 조회
const getReportDetail = (reportSeq, callback, errorHandler) => {
  return api.getPromise('GET', `/api/report/${reportSeq}/detail`)
}

// 보도자료 링크 공유 상세 조회
const getReportLink = (data = null, callback, errorHandler) => {
  return api.getPromise('GET', '/api/report/detail', data)
}

/* *****뉴스룸-팩트 FRONT API***** */

// 팩트 목록조회
const getFact = (data = null, callback, errorHandler) => {
  return api.getPromise('GET', '/api/fact', data)
}

// 팩트 상세 조회
const getFactDetail = (factSeq, callback, errorHandler) => {
  return api.getPromise('GET', `/api/fact/${factSeq}/detail`)
}

// 팩트 링크 공유 상세 조회
const getFactLink = (data = null, callback, errorHandler) => {
  return api.getPromise('GET', '/api/fact/detail', data)
}

/* *****뉴스룸-언론보도 FRONT API***** */

// 언론보도 목록 조회
const getMedia = (data = null, callback, errorHandler) => {
  return api.getPromise('GET', '/api/media', data)
}

// 언론보도 상세 조회
const getMediaDetail = (mediaSeq, callback, errorHandler) => {
  return api.getPromise('GET', `/api/media/${mediaSeq}/detail`)
}

// 언론보도 링크 공유 상세 조회
const getMediaLink = (data = null, callback, errorHandler) => {
  return api.getPromise('GET', '/api/media/detail')
}

export default {
  getReport,
  getReportDetail,
  getReportLink,

  getFact,
  getFactDetail,
  getFactLink,

  getMedia,
  getMediaDetail,
  getMediaLink,
}
